const ARABIC = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/;
const LATIN = /[A-Za-z]/;

/**
 * Direction for a run of text.
 *
 * Altibbi's newsletters are Arabic-heavy but rarely purely Arabic: a sentence
 * carries Latin medical terms, drug names, numbers and URLs. So direction is
 * decided by which script actually leads the content, not by whether any
 * Arabic is present — and "auto" is handed to the browser for genuinely mixed
 * runs, where the Unicode bidi algorithm does a better job than we would.
 */
export function directionOf(value: string): "rtl" | "ltr" | "auto" {
  const text = (value ?? "").trim();
  if (!text) return "auto";
  const arabic = (text.match(new RegExp(ARABIC, "g")) ?? []).length;
  const latin = (text.match(new RegExp(LATIN, "g")) ?? []).length;
  if (arabic === 0) return latin > 0 ? "ltr" : "auto";
  if (latin === 0) return "rtl";
  // Mixed: let the leading script decide, and fall back to auto when close.
  const ratio = arabic / (arabic + latin);
  if (ratio > 0.6) return "rtl";
  if (ratio < 0.25) return "ltr";
  return "auto";
}

export function directionLabel(dir: "rtl" | "ltr" | "auto"): string {
  if (dir === "rtl") return "RTL";
  if (dir === "ltr") return "LTR";
  return "Auto";
}
